export default __webpack_public_path__ + "static/media/R.ef488f2d.svg";